export const duckName = 'access-key'
